module.exports = __webpack_public_path__ + "static/wordcloud2_outline.min-bc332c49dbe6c0c39a18cf15bda2b296.svg";